/* eslint-disable react/jsx-newline, react/no-multi-comp, react/no-unstable-nested-components */
import { Col, Row } from "react-bootstrap";
import {
	ExclamationCircleIcon,
	GlobeIcon,
	MapIcon,
	PaperClipIcon,
	SupportIcon,
	TicketIcon
} from "@heroicons/react/outline";
import { Link, useParams } from "react-router-dom";

import CourseBody from "./components/CourseBody";
import CourseHeader from "./components/CourseHeader";
import CourseSidebarItem from "./components/CourseSidebarItem";
import { getCoursesBySeries } from "../../services/wp.courses.service";

const CourseSeries = () => {

	const { seriesId } = useParams();
	const seriesName = seriesId.replace("%20", " ");
	const series = {
		description: "Lorem ipsum dolor sit amet consectetur adipiscing elit fermentum, tortor justo risus venenatis habitant non vulputate.",
		title: `Series: ${seriesName}`
	};
	const { data: courseList } = getCoursesBySeries(seriesName);

	/*
	 * 1) These items are currently hard coded, but will
	 * need to be populated based on Class Series data.
	 *
	 * 2) Need to update to use Class Series meta fields.
	 * Currently just duplicating Class meta.
	 *
	 * 3) We can probably consolidate this entire
	 * file with ClassSingle.jsx.
	 */
	const sidebarItems = [
		{
			description: () => (
				<>
					<address>
						Life with Cancer Center<br />
						8411 Pennel St.
						Fairfax, VA 22031
					</address>

					<Link to="#">
						<p>
							View Map
						</p>
					</Link>
				</>
			),
			icon: MapIcon,
			title: "Location"
		},
		{
			description: () => (
				<p>
					This page provides information on our <Link to={`/class/${seriesName}`}>{seriesName}</Link> series of courses.
				</p>
			),
			icon: TicketIcon,
			title: "Series"
		},
		{
			description: "Content describing any requirements for class attendance.",
			icon: ExclamationCircleIcon,
			title: "Requirements"
		},
		{
			description: "Content describing any limitations for class attendance.",
			icon: PaperClipIcon,
			title: "Pre-requisites"
		},
		{
			description: "English, Spanish",
			icon: GlobeIcon,
			title: "Languages"
		},
		{
			description: "Content describing any limitations for class attendance.",
			icon: SupportIcon,
			title: "Limitations"
		}
	];

	return (
		<article className="course-single">
			<Row>
				<Col className="px-0">
					<CourseHeader course={series} />

					<CourseBody
						course={series}
						courseList={courseList instanceof Array ? [...courseList] : [{}]}
					/>
				</Col>

				<Col className="bg-white" lg={3} md={3} sm={12}>
					<aside className="py-4 px-2">
						{
							sidebarItems.map((item) => (
								<CourseSidebarItem
									Icon={item.icon}
									description={item.description}
									key={item.title}
									title={item.title}
								/>
							))
						}
					</aside>
				</Col>
			</Row>
		</article>
	);
};

export default CourseSeries;
